module.exports = __webpack_public_path__ + "img/hr-red-croton-01.1edca1fc.png";